/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ResetDefaultPasswordRequestViewModel } from "../types/ResetDefaultPasswordRequestViewModel.ts";

export const resetDefaultPasswordRequestViewModelSchema = z.object({
  password: z
    .string()
    .describe(
      "Nova senha permanente a ser definida para o usuário. Obrigatório.",
    )
    .nullish(),
}) as unknown as ToZod<ResetDefaultPasswordRequestViewModel>;
